import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class MainPageService {
  readonly rootUrl = AppSettings.webApiURL;

  constructor(public httpClient: HttpClient) { }

  getRoleAdministration() {
    return this.httpClient.get(`${this.rootUrl}/api/MainPageAPI/GetRoleAdministration`);
  }
  getRoleContactMan() {
    return this.httpClient.get(`${this.rootUrl}/api/MainPageAPI/GetRoleContactMan`);
  }
  getRoleCustomer() {
    return this.httpClient.get(`${this.rootUrl}/api/MainPageAPI/GetRoleCustomer`)
  }
  getContactManAndCustomer() {
    return this.httpClient.get(`${this.rootUrl}/api/MainPageAPI/GetDashboardContactManAndCustomer`)
  }
  getLastTotalsContactManAndCustomer() {
    return this.httpClient.get(`${this.rootUrl}/api/MainPageAPI/GetLastTotalsContactManAndCustomer`)
  }
  getAdministratorAndSupport() {
    return this.httpClient.get(`${this.rootUrl}/api/MainPageAPI/GetDashboardAdministratorAndSupport`)
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/main-page.service.ts